// extracted by mini-css-extract-plugin
export default {"timeCell":"TimeCell_timeCell__Mu1dj","cell":"TimeCell_cell__pgf6r"};